import {
  transactionFailed,
  transactionRejected,
  transactionSuccess,
} from "../../hooks/swal2";
import { toEther, toWei } from "../../utils/helpers";
import { getWeb3, stakingContract } from "../getContracts";

export const stakes = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods._contributions(account).call())
    ).toFixed(2);
  } catch (e) {
    //console.log("stakes", e);
    return "0";
  }
};

export const stakedAmount = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.returnStakeAmount(account).call())
    ).toFixed(2);
  } catch (e) {
    //console.log("stakes", e);
    return "0";
  }
};
export const getuserPurchased = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.checkContribution(account).call())
    ).toFixed(2);
  } catch (e) {
    //console.log("stakes", e);
    return "0.000";
  }
};

export const getIdoTokens = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getIDOTokens().call())
    ).toFixed(0);
  } catch (e) {
    //console.log("checkUnstakeStatus", e);
    return "0";
  }
};

export const getLiquidityTokens = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getLiquidityTokens().call())
    ).toFixed(0);
  } catch (e) {
    //console.log("checkUnstakeStatus", e);
    return "0";
  }
};

export const getUnlocked = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getUnlockedTokens().call())
    ).toFixed(0);
  } catch (e) {
    //console.log("checkUnstakeStatus", e);
    return "0";
  }
};

export const getLockedTokens = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getlockedTokens().call())
    ).toFixed(0);
  } catch (e) {
    //console.log("checkUnstakeStatus", e);
    return "0";
  }
};

export const getBurntTokens = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getBurnedToken().call())
    ).toFixed(0);
  } catch (e) {
    //console.log("checkUnstakeStatus", e);
    return "0";
  }
};


export const checkPurchased = async (account) => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods.getUserAllocation(account).call())
    ).toFixed(2);
  } catch (e) {
    console.log("checkPurchased", e);
    return "0";
  }
};

export const calculateEarnings = async () => {
  try {
    let contract = stakingContract();
    return parseFloat(
      toEther(await contract?.methods._weiRaised().call())
    ).toFixed(2);
  } catch (e) {
    //console.log("calculateEarnings", e);
    return "0";
  }
};

// --------------------------------------------------- write funcs

export const stake = async (account, referrer, amount, cb = () => {}) => {
  try {
    let txHash;
    let contract = stakingContract();
    await contract?.methods
      .buyTokens(toWei(amount))
      .send({
        from: account,
      })
      .on("transactionHash", (hash) => {
        txHash = hash;
      })
      .then((receipt) => {
        transactionSuccess();
      })
      .catch((e) => {
        if (e.code === 4001) {
          transactionRejected();
        } else if (e?.message?.includes("not mined within 50 blocks")) {
          const web3 = getWeb3();
          if (web3) {
            const handle = setInterval(() => {
              web3.eth.getTransactionReceipt(txHash).then((res) => {
                if (res != null && res.blockNumber > 0) {
                  clearInterval(handle);
                  if (res.status) {
                    transactionSuccess();
                  } else {
                    transactionFailed();
                  }
                }
              });
            });
          }
        } else {
          transactionFailed();
        }
      });
    cb();
  } catch (e) {
    //console.log("stake", e);
  }
};

export const unstake = async (account, amount, cb = () => {}) => {
  try {
    let txHash;
    let contract = stakingContract();
    await contract?.methods
      .unstake(toWei(amount))
      .send({
        from: account,
      })
      .on("transactionHash", (hash) => {
        txHash = hash;
      })
      .then((receipt) => {
        transactionSuccess();
      })
      .catch((e) => {
        if (e.code === 4001) {
          transactionRejected();
        } else if (e?.message?.includes("not mined within 50 blocks")) {
          const web3 = getWeb3();
          if (web3) {
            const handle = setInterval(() => {
              web3.eth.getTransactionReceipt(txHash).then((res) => {
                if (res != null && res.blockNumber > 0) {
                  clearInterval(handle);
                  if (res.status) {
                    transactionSuccess();
                  } else {
                    transactionFailed();
                  }
                }
              });
            });
          }
        } else {
          transactionFailed();
        }
      });
    cb();
  } catch (e) {
    //console.log("unstake", e);
  }
};

export const withdrawEarnings = async (account, cb = () => {}) => {
  try {
    let txHash;
    let contract = stakingContract();
    await contract?.methods
      .withdrawTokens()
      .send({
        from: account,
      })
      .on("transactionHash", (hash) => {
        txHash = hash;
      })
      .then((receipt) => {
        transactionSuccess();
      })
      .catch((e) => {
        if (e.code === 4001) {
          transactionRejected();
        } else if (e?.message?.includes("not mined within 50 blocks")) {
          const web3 = getWeb3();
          if (web3) {
            const handle = setInterval(() => {
              web3.eth.getTransactionReceipt(txHash).then((res) => {
                if (res != null && res.blockNumber > 0) {
                  clearInterval(handle);
                  if (res.status) {
                    transactionSuccess();
                  } else {
                    transactionFailed();
                  }
                }
              });
            });
          }
        } else {
          transactionFailed();
        }
      });
    cb();
  } catch (e) {
    //console.log("withdrawEarnings", e);
  }
};
